<script setup>
import { formatCurrency } from '../../helpers';
import OfferLine from './offer-line.vue';
import Button from '../ui/base-button.vue';
import { computed } from 'vue';

const props = defineProps({
    name: String,
    sumMax: Number,
    sumProperty: Number,
    sumThirdPartyInjury: Number,
    sumTenant: Number,
    price: Number,
    icon: String
});

const lines = computed(() => ([
    {
        title: 'business.offers.lines.first.title',
        subtitle: `business.offers.lines.first.subtitle`,
        sum: formatCurrency(props.sumProperty)
    }, {
        title: 'business.offers.lines.second.title',
        subtitle: `business.offers.lines.second.subtitle`,
        sum: formatCurrency(props.sumThirdPartyInjury)
    }, {
        title: 'business.offers.lines.third.title',
        subtitle: `business.offers.lines.third.subtitle`,
        sum: formatCurrency(props.sumTenant)
    }
]))

const handleClickOrder = () => {
    const id = window.screen.width >= 1280 ? "desktop-form" : "mobile-form";
    const form = document.getElementById(id);

    form.scrollIntoView({
        behavior: "smooth",
        block: "end"
    })
};
</script>

<template>
    <div class="card">
        <div class="card-head">
            <div class="icon">
                <img :src="props.icon" alt="">
            </div>

            <h3 class="name">
                <i18n-t keypath="business.offers.products.offer">
                    <template #break>
                        <br/>
                    </template>

                    <template #name>
                        <span class="corp-gradient">{{ props.name }}</span>
                    </template>
                </i18n-t>
            </h3>

            <p class="max-sum">
                {{ $t("business.offers.pay-from") }} <br/>
                <span class="sum">
                    {{ $t("business.offers.pay-from-sum", {money: formatCurrency(props.sumMax)}) }}
                </span>
            </p>
        </div>

        <div class="card-body">
            <p class="includes">
                {{ $t("business.offers.what-includes") }}:
            </p>

            <div class="lines">
                <div v-for="line in lines">
                    <OfferLine
                        v-bind="line"
                    />
                </div>
            </div>
        </div>

        <p class="price">
            {{ $t("business.offers.price", {money: formatCurrency(props.price)}) }}
        </p>

        <Button @click="handleClickOrder">
            {{ $t("business.offers.order") }}
        </Button>
    </div>
</template>

<style scoped>
.card {
    border: 2px solid #E5F2FF;
    padding: 21px 18px;

    display: flex;
    flex-direction: column;

    gap: 20px;
}

.card-head {
    position: relative;
    padding: 20px;
    background-color: #7dbcff1a;
}

.card-body {
    padding: 0;
}

.icon {
    position: absolute;
    top: 30px;
    right: 30px;
}

.name {
    font-family: "Segoe UI";
    font-size: 50px;
    font-weight: 400;
    text-transform: uppercase;
    color: #000000b3
}

.corp-gradient {
    background: linear-gradient(88.7deg, #FF143F -19.62%, #C600DD 51.14%, #1B27FF 121.98%);
    color: transparent;
    background-clip: text;

    font-weight: bold;
}

.max-sum {
    margin-top: 30px;
    margin-bottom: 0;

    color: #373737;
    font-size: 20px;

    line-height: 110%;
}

.sum {
    font-weight: 700;
    font-size: 30px;
    line-height: 115%;
}

.includes {
    font-size: 25px;
    font-weight: bold;
    color: #373737;
}

.lines {
    display: grid;
    gap: 20px;
}

.price {
    font-weight: 400;
    font-size: 25px;

    margin: 0;
}

@media screen and (max-width: 1280px) {
    .name {
        font-size: 30px;
    }

    .icon {
        position: static;
    }

    .max-sum {
        margin-top: 10px;
    }
}
</style>